import angular from 'angular';
import RetailerReportsFilterComponent from './retailer-reports-filter-component';

export default angular.module('retailer-reports-filter', []).component('retailerReportsFilter', new RetailerReportsFilterComponent());



// WEBPACK FOOTER //
// ./src/modules/retailer-reports/components/retailer-reports-filter/retailer-reports-filter-module.js